import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { ImagenesSatelitalesState } from './types'

export const state: ImagenesSatelitalesState = {
  inicio: new Date().toISOString(),
  imagenes: {
    NieveMODIS: [],
    PrecipitacionIMERG: []
  },
  pasos: 0,
  ruta: '',
  fecha_inicio_nieve: null,
  centro: [],
  latlong: [[]],
  delta: 0,
  etiquetas: {
  },
  icon: {
  },
  error: { state: false },
  timeline_config: {
    NieveMODIS: {
      inicio: '',
      delta: 0
    },
    PrecipitacionIMERG: {
      inicio: '',
      delta: 0
    }
  }
}

const namespaced: boolean = true

export const imagenesSatelitales: Module<ImagenesSatelitalesState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
